const API_URL = process.env.REACT_APP_API_URL;
const APPROVED_PRODUCT_AREA = API_URL + "/ApprovedProduct"

export const APPROVED_PRODUCT_GET_PROTOCOLVERSIONS_AND_LASTUPLOAD_DATE = APPROVED_PRODUCT_AREA + "/GetProtocolVersionsAndLastUploadDate"

export const APPROVED_PRODUCTS_GET_ALL = APPROVED_PRODUCT_AREA + "/GetAll";
export const APPROVED_PRODUCTS_GET_PUBLIC = APPROVED_PRODUCT_AREA + "/GetPublic"

export const APPROVED_PRODUCTS_EXPORT_ALL = APPROVED_PRODUCT_AREA + "/ExportAll"
export const APPROVED_PRODUCTS_EXPORT_PUBLIC = APPROVED_PRODUCT_AREA + "/ExportPublic"

